// process.env.REACT_APP_API_URL is used when deployed on AWS Amplify, localhost is for local development
export const SERVER_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

